/**
 * Lots of Parts - Product Gallery
 * Elegant hover-to-preview: thumbnails change main image on mouseover (no click required)
 */
(function() {
  'use strict';

  function initLOPProductGallery() {
    var $gallery = $('.template-product .lop-product-gallery');
    if (!$gallery.length) return;

    var $sliderFor = $gallery.find('.slider-for');
    var $sliderNav = $gallery.find('.slider-nav');
    var $thumbItems = $sliderNav.find('.product-single__thumbnails-item:not(.product-single__thumbnails-itemcustom)');

    if (!$sliderFor.length || !$thumbItems.length) return;

    var isSlick = $sliderFor.hasClass('slick-initialized');
    var isDesktop = $(window).width() >= 768;

    function showImageByThumbId(thumbId) {
      var $wrappers = $sliderFor.find('.product-single__photo-wrapper');
      $wrappers.removeClass('lop-active').css({ opacity: 0, visibility: 'hidden', zIndex: 1 });
      var $target = $sliderFor.find('.product-single__photo[data-image-id="' + thumbId + '"]').closest('.product-single__photo-wrapper');
      if ($target.length) {
        $target.addClass('lop-active').css({ opacity: 1, visibility: 'visible', zIndex: 2 });
      }
      $sliderNav.find('.product-single__thumbnail, .text-link').removeClass('lop-thumb-active');
      $sliderNav.find('[data-thumbnail-id="' + thumbId + '"]').addClass('lop-thumb-active');
    }

    function showImageByIndex(idx) {
      if (isSlick && typeof $sliderFor.slick === 'function') {
        $sliderFor.slick('slickGoTo', idx);
      }
    }

    // Unbind previous
    $thumbItems.off('mouseenter.lopGallery mouseleave.lopGallery click.lopGallery');

    $thumbItems.each(function() {
      var $item = $(this);
      var $thumb = $item.find('.product-single__thumbnail, .text-link[data-thumbnail-id], [data-thumbnail-id]').first();
      var thumbId = $thumb.data('thumbnail-id') || $thumb.attr('data-thumbnail-id');
      var slickIdx = $item.data('slick-index');

      if (!thumbId && typeof slickIdx !== 'number') return;

      $thumb.on('mouseenter.lopGallery', function(e) {
        if (isDesktop) {
          if (isSlick && typeof $sliderFor.slick === 'function') {
            showImageByIndex(slickIdx);
          } else {
            showImageByThumbId(thumbId);
          }
        }
      });

      $thumb.on('click.lopGallery', function(e) {
        if (isDesktop) {
          e.preventDefault();
          e.stopPropagation();
          if (isSlick && typeof $sliderFor.slick === 'function') {
            showImageByIndex(slickIdx);
          } else {
            showImageByThumbId(thumbId);
          }
        }
      });
    });

    // Non-Slick desktop: stack wrappers and show first
    if (!isSlick && isDesktop) {
      $sliderFor.addClass('lop-hover-mode');
      $sliderFor.find('.product-single__photo-wrapper').each(function(i) {
        var $wrap = $(this);
        var $photo = $wrap.find('.product-single__photo');
        var imageId = $photo.data('image-id') || $photo.attr('data-image-id');
        if (imageId) {
          if (i === 0) {
            $wrap.addClass('lop-active').css({ opacity: 1, visibility: 'visible', zIndex: 2 });
          } else {
            $wrap.css({ opacity: 0, visibility: 'hidden', zIndex: 1 });
          }
        }
      });
    } else {
      $sliderFor.removeClass('lop-hover-mode');
    }
  }

  $(document).ready(function() {
    setTimeout(initLOPProductGallery, 100);
  });

  document.addEventListener('shopify:section:load', initLOPProductGallery);

  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initLOPProductGallery, 300);
  });
})();
